import apiClient from './client';

// Team Whereabouts — pan-by-month location grid (Shanti's spec).
// Served by Hyrule GET /api/v1/whereabouts/month; called with the user's JWT.
//
// Shanti asked to pan a full year (2026-07-08), so we fetch 12 months ahead in
// one call. The backend reads each calendar ONCE for the whole window and serves
// it from a nightly snapshot, so a year costs no more API calls than a month.
// A backend older than the year-window change caps `months_ahead` at 3 and 422s
// on 12. Rather than blank the tab during a rollout (or a rollback), fall back
// once to the widest window every revision accepts. Only on 422 — a real outage
// must still surface as an error.
const LEGACY_MAX_MONTHS = 3;

export const whereaboutsApi = {
  getMonthGrid: async (monthsAhead = 12) => {
    const fetchGrid = (m) =>
      apiClient.get('/api/v1/whereabouts/month', { params: { months_ahead: m } });

    try {
      const response = await fetchGrid(monthsAhead);
      return response.data;
    } catch (e) {
      if (e?.response?.status !== 422 || monthsAhead <= LEGACY_MAX_MONTHS) throw e;
      const response = await fetchGrid(LEGACY_MAX_MONTHS);
      return response.data;
    }
  },
};
